// LoadingContext.js
import React, { createContext, useContext, useState } from 'react';
import { StringKeys } from '../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

/**
 * This component assists in displaying the loading Compass PRO screen on startup
 * @param normalUserSignalRStatus - The status of a normal non-Safeguard permission user's SignalR connection
 * @param safeguardUserSignalRStatus - The status of a Safeguard permission user's SignalR connection
 * @param pageLoading - Controls whether the loading screen should be displayed
 * @param transitionComplete - Keeps track of whether ransition from Compass PRO loading screen to home page is complete
 * @param loadingText - The text to display in the loading screen
 */

export const LoadingProvider = ({ children }) => {
  const { t } = useTranslation();
  const [normalUserSignalRStatus, setNormalUserSignalrStatus] = useState();
  const [safeguardUserSignalRStatus, setSafeguardUserSignalrStatus] =
    useState();
  const [pageLoading, setPageLoading] = useState(true);
  const [transitionComplete, setTransitionComplete] = useState(false);
  const [loadingText, setLoadingText] = useState(t(StringKeys.LOADING));

  return (
    <LoadingContext.Provider
      value={{
        normalUserSignalRStatus,
        setNormalUserSignalrStatus,
        safeguardUserSignalRStatus,
        setSafeguardUserSignalrStatus,
        setPageLoading,
        pageLoading,
        loadingText,
        setLoadingText,
        transitionComplete,
        setTransitionComplete,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
